import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  PRICING_CLEAR_DATA,
  PRICING_SELECT_LANGUAGE,
  PRICING_DATA_FETCH,
  PRICING_DATA_SUCCESS,
  PRICING_DATA_FAILURE,
  UPDATE_PRICING_DATA_FETCH,
  UPDATE_PRICING_DATA_SUCCESS,
  UPDATE_PRICING_DATA_FAILURE
} from './actionTypes';

//<<<---CLEAR-DATA--->>>
export const clearData = createAction(PRICING_CLEAR_DATA);

//<<<---SELECT_LANGUAGE--->>>
export const selectLangugeAction = createAction(PRICING_SELECT_LANGUAGE);

export const selectLanguge = lang => dispatch => {
  dispatch(clearData());
  dispatch(selectLangugeAction(lang));
  dispatch(fetchPricingData(lang));
};

//<<<---FETCH-PRICING-DATA--->>>
export const pricingDataFetch = createAction(PRICING_DATA_FETCH);
export const pricingDataSuccess = createAction(PRICING_DATA_SUCCESS);
export const pricingDataFailure = createAction(PRICING_DATA_FAILURE);

export const fetchPricingData = lang => async dispatch => {
  dispatch(pricingDataFetch());
  try {
    const res = await api.get(`price/${lang}`);
    dispatch(pricingDataSuccess(res.data));
  } catch (error) {
    dispatch(pricingDataFailure(error));
  }
};

//<<<---UPDATE-PRICING-DATA--->>>
export const updatePricingDataFetch = createAction(UPDATE_PRICING_DATA_FETCH);
export const updatePricingDataSuccess = createAction(
  UPDATE_PRICING_DATA_SUCCESS
);
export const updatePricingDataFailure = createAction(
  UPDATE_PRICING_DATA_FAILURE
);

export const updatePricingData = (formData, id, lang) => async dispatch => {
  dispatch(updatePricingDataFetch());
  try {
    const res = await api.post(`price/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    dispatch(clearData());
    dispatch(updatePricingDataSuccess(data));
  } catch (error) {
    dispatch(updatePricingDataFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/Pricing/actions.js